import createCollectionResource from 'src/actions/shared/createResource';
import { AgentProfile } from './agentProfileResource';

export default createCollectionResource<AgentProfile>({
  name: 'agentProfiles',

  endpoint: {
    broadcastDeleteTopic: 'v3/orgs/:orgId/agent-profiles/:id/event/delete',
    broadcastTopic: 'v3/orgs/:orgId/agent-profiles/:id',
    collectionBroadcastTopic: 'v3/orgs/:orgId/agent-profiles/+',
    fetchAllUrl: '/api/v3/orgs/:orgId/agent-profiles',
  },
  observerCreator: ({ actions }) => {
    return ({ dispatch }) => {
      return {
        onBroadcast(item) {
          dispatch(actions.broadcast(item));
        },
        onUpdateSuccess(item) {
          if (item) {
            dispatch(actions.broadcast(item));
          }
        },
        onAddSuccess(item) {
          if (item) {
            dispatch(actions.broadcast(item));
          }
        },
      };
    };
  },
});
